export default __webpack_public_path__ + "static/media/inline_crm.0f28d621.png";